document.addEventListener('DOMContentLoaded', function() {
  console.log('✅ Quote script loaded');

  // Find all quote buttons
  const quoteButtons = document.querySelectorAll('[data-block-id]');

  quoteButtons.forEach(button => {
    const blockId = button.getAttribute('data-block-id');
    let minDays = parseInt(button.getAttribute('data-min-days')) || 3;
    const whatsappNum = button.getAttribute('data-whatsapp');
    const productName = button.getAttribute('data-product');
    const productType = button.getAttribute('data-product-type') || '';

    let typeNoticeMap = {};
    try {
      typeNoticeMap = JSON.parse(button.getAttribute('data-type-notice-map') || '{}');
    } catch (err) {
      typeNoticeMap = {};
    }
    if (typeNoticeMap[productType]) {
      minDays = parseInt(typeNoticeMap[productType], 10) || minDays;
    }

    const typeSelect = document.getElementById('quote-type-' + blockId);
    const addressWrapper = document.getElementById('quote-address-wrapper-' + blockId);
    const addressLine1 = document.getElementById('quote-address-line1-' + blockId);
    const addressLine2 = document.getElementById('quote-address-line2-' + blockId);
    const addressCity = document.getElementById('quote-address-city-' + blockId);
    const postcodeSelect = document.getElementById('quote-postcode-' + blockId);
    const addressState = document.getElementById('quote-address-state-' + blockId);

    function syncSelectPlaceholderStyle(select) {
      if (!select) {
        return;
      }
      select.classList.toggle('cake-select--has-value', select.value !== '');
    }

    // Mirrors the buy-it-now modal's postcode dropdown: populated from the same
    // delivery-rate table, with out-of-coverage codes shown but disabled.
    function populatePostcodeOptions() {
      if (!postcodeSelect || typeof POSTCODE_DELIVERY_RATES === 'undefined') {
        return;
      }
      const codes = Object.keys(POSTCODE_DELIVERY_RATES).sort(function(a, b) {
        return Number(a) - Number(b);
      });
      codes.forEach(function(code) {
        const rate = POSTCODE_DELIVERY_RATES[code];
        const option = document.createElement('option');
        option.value = code;
        if (rate === null) {
          option.textContent = code + ' (not covered)';
          option.disabled = true;
        } else {
          option.textContent = code;
        }
        postcodeSelect.appendChild(option);
      });
    }

    // Auto-fills City and State from the selected postal code, same as buy-it-now.
    function applyPostcodeInfo() {
      if (!postcodeSelect || typeof POSTCODE_DELIVERY_INFO === 'undefined') {
        return;
      }
      const code = postcodeSelect.value.trim();
      const info = POSTCODE_DELIVERY_INFO[code];
      if (!info) {
        return;
      }
      if (addressCity) {
        addressCity.value = info.area;
      }
      if (addressState) {
        addressState.value = info.state;
        syncSelectPlaceholderStyle(addressState);
      }
    }

    function toggleAddressFields() {
      const isPickup = typeSelect && typeSelect.value === 'Pickup';
      if (addressWrapper) {
        // 'grid' (not 'block') so City/Postcode/State keep their one-row layout
        // — see the #quote-address-wrapper-{{ block.id }} rules.
        addressWrapper.style.display = isPickup ? 'none' : 'grid';
      }
      [addressLine1, addressCity, postcodeSelect, addressState].forEach(function(field) {
        if (!field) {
          return;
        }
        if (isPickup) {
          field.removeAttribute('required');
        } else {
          field.setAttribute('required', 'required');
        }
      });
      if (isPickup) {
        [addressLine1, addressLine2, addressCity, postcodeSelect, addressState].forEach(function(field) {
          if (field) {
            field.value = '';
            syncSelectPlaceholderStyle(field);
          }
        });
      }
    }

    populatePostcodeOptions();
    toggleAddressFields();

    if (typeSelect) {
      typeSelect.addEventListener('change', toggleAddressFields);
    }
    if (postcodeSelect) {
      postcodeSelect.addEventListener('change', applyPostcodeInfo);
    }

    // Keep each select's text gray while its placeholder option is selected, to
    // match the input/textarea placeholder color (see the <style> block next to
    // the modal markup).
    [typeSelect, postcodeSelect, addressState].forEach(function(select) {
      if (!select) {
        return;
      }
      const syncPlaceholderStyle = function() {
        syncSelectPlaceholderStyle(select);
      };
      syncPlaceholderStyle();
      select.addEventListener('change', syncPlaceholderStyle);
    });

    // Open modal
    button.addEventListener('click', function(e) {
      e.preventDefault();
      console.log('Opening modal for:', blockId);

      const modal = document.getElementById('quoteModal_' + blockId);
      if (modal) {
        modal.style.display = 'block';

        // Set minimum date (local calendar date, not UTC — toISOString() would roll
        // back to the previous day during early-morning hours for UTC+8 stores)
        const minDate = new Date();
        minDate.setDate(minDate.getDate() + minDays);
        const minDateStr = minDate.getFullYear() + '-' +
          String(minDate.getMonth() + 1).padStart(2, '0') + '-' +
          String(minDate.getDate()).padStart(2, '0');

        const dateInput = document.getElementById('quote-date-' + blockId);
        if (dateInput) {
          dateInput.setAttribute('min', minDateStr);
          dateInput.value = minDateStr;
        }

        // Hide warning
        const warning = document.getElementById('quoteWarning_' + blockId);
        if (warning) {
          warning.style.display = 'none';
        }
      }
    });

    // Close modal on X
    const closeBtn = document.getElementById('close-' + blockId);
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        const modal = document.getElementById('quoteModal_' + blockId);
        if (modal) {
          modal.style.display = 'none';
        }
      });
    }

    // Close modal on outside click
    const modal = document.getElementById('quoteModal_' + blockId);
    if (modal) {
      // The modal is `position: fixed`, but an ancestor in the product-info column
      // (Dawn's sticky/gallery layout) applies a transform/contain, which creates a
      // new containing block and pins the "fixed" overlay to that column instead of
      // the viewport — it visually appears docked to one side of the screen. Moving
      // the modal to <body> escapes that ancestor entirely.
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }

      modal.addEventListener('click', function(e) {
        if (e.target === this) {
          this.style.display = 'none';
        }
      });
    }

    // Send to WhatsApp
    const sendBtn = document.getElementById('send-quote-' + blockId);
    if (sendBtn) {
      sendBtn.addEventListener('click', function(e) {
        e.preventDefault();

        const date = document.getElementById('quote-date-' + blockId).value;
        const type = document.getElementById('quote-type-' + blockId).value;
        const notes = document.getElementById('quote-notes-' + blockId).value;

        const isDelivery = type === 'Delivery Service';
        const line1 = addressLine1 ? addressLine1.value.trim() : '';
        const line2 = addressLine2 ? addressLine2.value.trim() : '';
        const city = addressCity ? addressCity.value.trim() : '';
        const postcode = postcodeSelect ? postcodeSelect.value.trim() : '';
        const state = addressState ? addressState.value : '';

        const warning = document.getElementById('quoteWarning_' + blockId);

        // Check if all fields filled
        const addressComplete = !isDelivery || (line1 && city && postcode && state);
        if (!date || !type || !addressComplete) {
          console.warn('❌ Missing fields');
          if (warning) {
            warning.style.display = 'block';
          }
          return;
        }

        // Hide warning
        if (warning) {
          warning.style.display = 'none';
        }

        // Build a single address line, same shape as the buy-it-now order details
        let addressText = 'Self Pickup';
        if (isDelivery) {
          const addressParts = [line1];
          if (line2) {
            addressParts.push(line2);
          }
          const cityLine = [postcode, city].filter(Boolean).join(' ');
          if (cityLine) {
            addressParts.push(cityLine);
          }
          if (state) {
            addressParts.push(state);
          }
          addressText = addressParts.join(', ');
        }

        // Build message
        const message = `QUOTE REQUEST%0A%0AProduct: ${productName}%0ADelivery Date: ${date}%0ADelivery Type: ${type}%0AAddress: ${addressText}%0ANotes: ${notes || 'None'}%0APage: ${encodeURIComponent(window.location.href)}`;

        console.log('✅ Sending to WhatsApp');
        window.open(`https://wa.me/${whatsappNum}?text=${message}`, '_blank');

        // Close modal
        const modal = document.getElementById('quoteModal_' + blockId);
        if (modal) {
          modal.style.display = 'none';
        }
      });
    }
  });
});
